export default __webpack_public_path__ + "assets/384c20cafbd2d76f0ff620edbd90de03.woff2";